import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from './AuthContext';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminProductEditor from './pages/AdminProductEditor';
import AdminMedia from './pages/AdminMedia';
import AdminHomepage from './pages/AdminHomepage';
import AdminCampaigns from './pages/AdminCampaigns';
import AdminDealers from './pages/AdminDealers';
import AdminDealerDetail from './pages/AdminDealerDetail';
import AdminOrders from './pages/AdminOrders';
import AdminOrderDetail from './pages/AdminOrderDetail';
import AdminProduction from './pages/AdminProduction';
import AdminShopFloor from './pages/AdminShopFloor';
import AdminSerialization from './pages/AdminSerialization';
import AdminShipping from './pages/AdminShipping';
import AdminDocumentPacket from './pages/AdminDocumentPacket';
import AdminDemo from './pages/AdminDemo';
import AdminAuditLog from './pages/AdminAuditLog';
import AdminCompliance from './pages/AdminCompliance';
import AdminInventory from './pages/AdminInventory';
import AdminProductionPlanner from './pages/AdminProductionPlanner';
import AdminPaymentRules from './pages/AdminPaymentRules';
import AdminCutSheetEngine from './pages/AdminCutSheetEngine';
import AdminQuotes from './pages/AdminQuotes';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
          <span className="font-inter text-sm text-zinc-500">Loading...</span>
        </div>
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}

function AdminInner() {
  const { isAuthenticated } = useAdminAuth();
  return (
    <Routes>
      <Route
        path="login"
        element={isAuthenticated ? <Navigate to="/admin" replace /> : <AdminLogin />}
      />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Routes>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductEditor />} />
                <Route path="products/:id" element={<AdminProductEditor />} />
                <Route path="media" element={<AdminMedia />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="campaigns" element={<AdminCampaigns />} />
                <Route path="dealers" element={<AdminDealers />} />
                <Route path="dealers/:id" element={<AdminDealerDetail />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="orders/:id" element={<AdminOrderDetail />} />
                <Route path="production" element={<AdminProduction />} />
                <Route path="serialization" element={<AdminSerialization />} />
                <Route path="shipping" element={<AdminShipping />} />
                <Route path="demo" element={<AdminDemo />} />
                <Route path="audit" element={<AdminAuditLog />} />
                <Route path="compliance" element={<AdminCompliance />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="production/plan/:planId" element={<AdminProductionPlanner />} />
                <Route path="shop-floor" element={<AdminShopFloor />} />
                <Route path="payment-rules" element={<AdminPaymentRules />} />
                <Route path="cut-sheet" element={<AdminCutSheetEngine />} />
                <Route path="quotes" element={<AdminQuotes />} />
              </Routes>
            </AdminLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminInner />
    </AdminAuthProvider>
  );
}
